import { ToastrService } from 'ngx-toastr';

import { checkCodeApi, StatusCode, StatusCodeData, statusCodeSuccess } from './../commons/ultis/status.code';
// tslint:disable:variable-name
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { PaginatorState } from '../models/paginator.model';
import { FillterCustomModel, ITableState, TableResponseModel } from '../models/table.model';
import { BaseModel } from '../models/base.model';
import { SortState } from '../models/sort.model';
import { GroupingState } from '../models/grouping.model';
import { environment } from '../../../environments/environment';
import { getHeaderToken } from '../helpers/http-utils';
import { CookieService } from 'ngx-cookie-service';
import { KEY_API } from '../_const/common/message.api';
import { CONST_FIELD_SEARCH_BASE } from '../_const/common/field.search.base';
import { CONST_MESSAGE_DECENTRALIZATION } from '../_const/common/api-message-decentralization';


const DEFAULT_STATE: ITableState = {
  filter: {},
  paginator: new PaginatorState(),
  sorting: new SortState(),
  searchTerm: '',
  grouping: new GroupingState(),
  entityId: undefined
};

export abstract class ApiService<T> {
  // Private fields
  public _items$ = new BehaviorSubject<T[]>([]);
  public _isLoading$ = new BehaviorSubject<boolean>(false);
  private _isFirstLoading$ = new BehaviorSubject<boolean>(true);
  private _tableState$ = new BehaviorSubject<ITableState>(DEFAULT_STATE);
  public _errorMessage = new BehaviorSubject<string>('');
  public _errorMessageFind = new BehaviorSubject<string>('');
  private _subscriptions: Subscription[] = [];
  public _httpHeaders: HttpHeaders;
  keyApis = KEY_API;
  // Getters
  get items$() {
    return this._items$.asObservable();
  }
  get isLoading$() {
    return this._isLoading$.asObservable();
  }
  get isFirstLoading$() {
    return this._isFirstLoading$.asObservable();
  }
  get errorMessage$() {
    return this._errorMessage.asObservable();
  }
  get subscriptions() {
    return this._subscriptions;
  }
  // State getters
  get paginator() {
    return this._tableState$.value.paginator;
  }
  get filter() {
    return this._tableState$.value.filter;
  }
  get sorting() {
    return this._tableState$.value.sorting;
  }
  get searchTerm() {
    return this._tableState$.value.searchTerm;
  }
  get grouping() {
    return this._tableState$.value.grouping;
  }
  constFieldSearchBase = CONST_FIELD_SEARCH_BASE;
  constMessageDecentralization = CONST_MESSAGE_DECENTRALIZATION;
  protected http: HttpClient;
  protected _toast: ToastrService;
  // API URL has to be overrided
  API_URL = `${environment.apiUrl}`;
  API_ADMIN_URL = `${environment.apiUrl}`;
  API_EOFFICE_URL = `${environment.apiUrlEoffice}/eoffice`;
  constructor(
    http: HttpClient,
    toast: ToastrService,
    _cookie: CookieService) {
    this.http = http;
    this._toast = toast;
    this._httpHeaders = getHeaderToken(_cookie);
  }

  // CREATE
  // server should return the object with ID
  create(item: BaseModel): Observable<BaseModel> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}`;
    return this.http.post<BaseModel>(url, item, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Thêm mới thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('CREATE ITEM', err);
        this._toast.error('Thêm mới thất bại');
        return of({ id: undefined });
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }
  assignFolderReport(item: BaseModel): Observable<BaseModel> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}`;
    return this.http.post<BaseModel>(url, item, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Phân quyền thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('CREATE ITEM', err);
        this._toast.error('Phân quyền thất bại');
        return of({ id: undefined });
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }
  addPossitionOrganization(item: BaseModel): Observable<BaseModel> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}`;
    return this.http.post<BaseModel>(url, item, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Thêm mới thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('CREATE ITEM', err);
        this._toast.error('Thêm mới thất bại');
        return of({ id: undefined });
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }
  createReturnItemV2(item: BaseModel) {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}`;
    return this.http.post<T>(url, item, { headers: this._httpHeaders || null }).toPromise()
      .then((res: T) => {
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = 200;
        statusCode.data = res;
        return statusCode;
      })
      .catch((err) => {
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = err.status;
        return checkCodeApi(statusCode, err);
      }).finally(() => this._isLoading$.next(false));
  }

  createFormData(item: FormData): Observable<BaseModel> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}`;
    return this.http.post<BaseModel>(url, item, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Thêm mới thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('CREATE ITEM', err);
        this._toast.error('Thêm mới thất bại');
        return of({ id: undefined });
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  createFormDataV2(item: FormData) {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}`;
    return this.http.post<T>(url, item, { headers: this._httpHeaders || null }).toPromise()
      .then((res: T) => {
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = 200;
        statusCode.data = res;
        return statusCode;
      })
      .catch((err) => {
        // const datas: OrganizationModel[] = [];
        // return datas;
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = err.status;
        return checkCodeApi(statusCode, err);
      }).finally(() => this._isLoading$.next(false));;
  }

  // READ (Returning filtered list of entities)
  find(tableState: ITableState, filterCustom: FillterCustomModel[], path?: string, isPage: boolean = false): Observable<TableResponseModel<T>> {
    var url = `${this.API_URL}`;
    if (path) {
      url += `/${path}`;
    } else {
      url += '/search';
    }
    this._errorMessageFind.next('');
    this._errorMessage.next('');
    const request = {
      PageIndex: tableState.paginator.page,
      PageSize: tableState.paginator.pageSize,
      IsPaging: tableState.paginator.isPaging,
      keyword: tableState.searchTerm || null
    };
    let params = new HttpParams();
    params = params.append(this.constFieldSearchBase.PageIndex, request.PageIndex.toString());
    params = params.append(this.constFieldSearchBase.PageSize, request.PageSize.toString());
    if (isPage == true) {
      params = params.append(this.constFieldSearchBase.IsPaging, request.IsPaging.toString());
    }
    if (request.keyword && request.keyword.trim()) {
      params = params.append(this.constFieldSearchBase.Keyword, request.keyword);
    }

    if (filterCustom && filterCustom.length > 0) {
      filterCustom.forEach((x: FillterCustomModel) => {
        params = params.append(x.keyParam, x.valueParam);
      });
    }
    // tslint:disable-next-line: object-literal-shorthand
    return this.http.get<TableResponseModel<T>>(url, { headers: this._httpHeaders || null, params: params }).pipe(
      map((response: TableResponseModel<T>) => {
        const result: TableResponseModel<T> = {
          items: response.items,
          totalRecords: response.totalRecords
        };
        this.patchStateWithoutFetch({
          paginator: this._tableState$.value.paginator.recalculatePaginator(
            response.totalRecords, response.items.length
          ),
        });
        return result;
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('FIND ITEMS', err);
        return of({ items: [], totalRecords: 0 });
      })
    );
  }

  getItemById(id: string): Observable<BaseModel> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}/${id}`;
    return this.http.get<BaseModel>(url, { headers: this._httpHeaders || null }).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('GET ITEM BY IT', id, err);
        this._toast.error('Không thể truy xuất dữ liệu!');
        return of({ id: undefined });
      }),
      finalize(() => this._isLoading$.next(false))
    );
  }

  // UPDATE
  update(item: BaseModel): Observable<any> {
    const url = `${this.API_URL}`;
    this._isLoading$.next(true);
    this._errorMessage.next('');
    return this.http.put(url, item, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Cập nhật thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('UPDATE ITEM', item, err);
        this._toast.error('Cập nhật thất bại');
        return of(item);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }
  createReturnItemReturnMessage(item: BaseModel) {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}`;
    return this.http.post<T>(url, item, { headers: this._httpHeaders || null }).toPromise()
      .then((res: T) => {
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = 200;
        statusCode.data = res;
        return statusCode;
      })
      .catch((err) => {
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = err.status;
        statusCode.message = err.error.message;
        return statusCode;
      }).finally(() => this._isLoading$.next(false));
  }

  updateReturnResultV2(item: BaseModel, path?: string) {
    let url = `${this.API_URL}`;
    if (path && path !== '') {
      url = `${url}/${path}`;
    }
    this._isLoading$.next(true);
    this._errorMessage.next('');
    return this.http.put(url, item, { headers: this._httpHeaders || null }).toPromise()
      .then((res: T) => {
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = 200;
        statusCode.data = res;
        return statusCode;
      })
      .catch((err) => {
        // const datas: OrganizationModel[] = [];
        // return datas;
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = err.status;
        return checkCodeApi(statusCode, err);
      }).finally(() => this._isLoading$.next(false));;
  }

  updateFormData(item: FormData): Observable<BaseModel> {
    const url = `${this.API_URL}`;
    this._isLoading$.next(true);
    this._errorMessage.next('');
    return this.http.put<BaseModel>(url, item, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Cập nhật thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('UPDATE ITEM', item, err);
        this._toast.error('Cập nhật thất bại');
        return of({ id: undefined });
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  updateFormDataV2(item: FormData) {
    const url = `${this.API_URL}`;
    this._isLoading$.next(true);
    this._errorMessage.next('');
    return this.http.put<T>(url, item, { headers: this._httpHeaders || null }).toPromise()
      .then((res: T) => {
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = 200;
        statusCode.data = res;
        return statusCode;
      })
      .catch((err) => {
        // const datas: OrganizationModel[] = [];
        // return datas;
        const statusCode: StatusCodeData<T> = new StatusCodeData<T>();
        statusCode.code = err.status;
        return checkCodeApi(statusCode, err);
      }).finally(() => this._isLoading$.next(false));
  }

  // UPDATE Status
  updateStatusForItems(ids: string[], status: boolean): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const body = { ids, status };
    const url = `${this.API_URL}/update-status`;
    return this.http.put(url, body, { headers: this._httpHeaders || null }).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('UPDATE STATUS FOR SELECTED ITEMS', ids, status, err);
        return of([]);
      }),
      finalize(() => this._isLoading$.next(false))
    );
  }

  updateStatusItems(ids: string, status: boolean): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const body = { ids, status };
    const url = `${this.API_URL}/update-status`;
    return this.http.put(url, body, { headers: this._httpHeaders || null }).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('UPDATE STATUS FOR SELECTED ITEMS', ids, status, err);
        return of([]);
      }),
      finalize(() => this._isLoading$.next(false))
    );
  }

  updateStatusForItemsParam(ids: string[], status: boolean): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const body = ids;
    const url = `${this.API_URL}/update-status`;
    return this.http.put(url, body, { headers: this._httpHeaders || null, params: { status: status.toString() } }).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('UPDATE STATUS FOR SELECTED ITEMS', ids, status, err);
        return of([]);
      }),
      finalize(() => this._isLoading$.next(false))
    );
  }

  // DELETE
  delete(id: any): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}/${id}`;
    return this.http.delete(url, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Xóa thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('DELETE ITEM', id, err);
        this._toast.error('Xóa thất bại');
        return of({});
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // delete list of items
  deleteItems(ids: string[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}/deletes`;
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Xóa thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('DELETE SELECTED ITEMS', ids, err);
        this._toast.error('Xóa thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // assign users to role
  assignUsers(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}/add-user`;
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Gán người dùng thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('ASSIGN SELECTED USERS', ids, err);
        this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // remove users from role
  removeUsers(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URL}/remove-user`;
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Bỏ gán người dùng thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('REMOVE SELECTED USERS', ids, err);
        this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // grant permission menu roles
  assignRoles(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-list';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Phân quyền thành công');
      }),
      catchError(err => {
        if (err && err.error && err.error.code === '400') {
          this._toast.error(err.error.message);
        }
        else {
          this._toast.error('Thao tác thất bại');
        }
        // this._errorMessage.next(err);
        // console.error('GRANT MENU PERMISSION', ids, err);
        // this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // grant permission menu groups
  assignGroups(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-menu-list-group';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Phân quyền thành công');
      }),
      catchError(err => {
        if (err && err.error && err.error.code === '400') {
          this._toast.error(err.error.message);
        }
        else {
          this._toast.error('Thao tác thất bại');
        }
        // this._errorMessage.next(err);
        // console.error('GRANT MENU PERMISSION', ids, err);
        // this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // remove permission menu roles
  removeRoles(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-list';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Bỏ gán vai trò thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('GRANT MENU PERMISSION', ids, err);
        this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // remove permission menu groups
  removeGroups(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-menu-group';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Bỏ gán nhóm người dùng thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('GRANT MENU PERMISSION', ids, err);
        this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }


  deleteRoles(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-list';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Xóa thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('GRANT MENU PERMISSION', ids, err);
        this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // grant permission menu roles
  assignWidgetRoles(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-widget-list';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Phân quyền thành công');
      }),
      catchError(err => {
        if (err && err.error && err.error.code === '400') {
          this._toast.error(err.error.message);
        }
        else {
          this._toast.error('Thao tác thất bại');
        }
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // grant permission menu roles
  removeWidgetRoles(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-widget-list';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Bỏ gán nhóm người dùng thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('GRANT WIDGET PERMISSION', ids, err);
        this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // grant permission menu roles
  assignWidgetGroups(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-widget-list-group';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Phân quyền thành công');
      }),
      catchError(err => {
        if (err && err.error && err.error.code === '400') {
          this._toast.error(err.error.message);
        }
        else {
          this._toast.error('Thao tác thất bại');
        }
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  // grant permission menu groups
  removeWidgetGroups(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-widget-list-group';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Bỏ gán nhóm người dùng thành công');
      }),
      catchError(err => {
        this._errorMessage.next(err);
        console.error('GRANT WIDGET PERMISSION', ids, err);
        this._toast.error('Thao tác thất bại');
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  public fetch(filterCustom: FillterCustomModel[] = null, path?: string, isPage: boolean = false) {
    this._isLoading$.next(true);
    this._errorMessageFind.next('');
    this._errorMessage.next('');
    const request = this.find(this._tableState$.value, filterCustom, path, isPage)
      .pipe(
        tap((res: TableResponseModel<T>) => {
          this._items$.next(res.items);
          this.patchStateWithoutFetch({
            paginator: this._tableState$.value.paginator.recalculatePaginator(
              res.totalRecords, res.items.length
            ),
          });
        }),
        catchError((err) => {
          this._errorMessageFind.next(err);
          this._errorMessage.next('');
          return of({
            items: [],
            total: 0
          });
        }),
        finalize(() => {
          this._isLoading$.next(false);
          const itemIds = this._items$.value.map((el: T) => {
            const item = (el as unknown) as BaseModel;
            return item.id;
          });
          this.patchStateWithoutFetch({
            grouping: this._tableState$.value.grouping.clearRows(itemIds),
          });
        })
      )
      .subscribe();
    this._subscriptions.push(request);
  }

  public setDefaults() {
    this.patchStateWithoutFetch({ filter: {} });
    this.patchStateWithoutFetch({ sorting: new SortState() });
    this.patchStateWithoutFetch({ grouping: new GroupingState() });
    this.patchStateWithoutFetch({ searchTerm: '' });
    this.patchStateWithoutFetch({
      paginator: new PaginatorState()
    });
    this._isFirstLoading$.next(true);
    this._isLoading$.next(true);
    this._tableState$.next(DEFAULT_STATE);
    this._errorMessage.next('');
  }

  public patchStateMenuRole(patch: Partial<ITableState>, filterCustom: FillterCustomModel[] = null) {
    this.patchStateWithoutFetch(patch);
    this.fetch(filterCustom);
  }

  // Base Methods
  public patchState(patch: Partial<ITableState>, filterCustom: FillterCustomModel[] = null, path?: string, isPage: boolean = false) {
    this.patchStateWithoutFetch(patch);
    this.fetch(filterCustom, path, isPage);
  }

  public patchStateWithoutFetch(patch: Partial<ITableState>) {
    const newState = Object.assign(this._tableState$.value, patch);
    this._tableState$.next(newState);
  }

  downloadTemplateExcel() {
    return this.http.get(`${this.API_URL}/download-template`, {
      responseType: 'blob', headers: this._httpHeaders, observe: 'response'
    }
    ).toPromise()
      .then((res) => {
        const success = statusCodeSuccess();
        success.data = res;
        return success;
      }).catch((err) => {
        const stautsCode = new StatusCode();
        stautsCode.code = err.status;
        return checkCodeApi(stautsCode, err);
      });
  }

  exportExcel() {
    return this.http.get(`${this.API_URL}/export`, {
      responseType: 'blob', headers: this._httpHeaders, observe: 'response'
    }
    ).toPromise()
      .then((res) => {
        const success = statusCodeSuccess();
        success.data = res;
        return success;
      }).catch((err) => {
        const stautsCode = new StatusCode();
        stautsCode.code = err.status;
        return checkCodeApi(stautsCode, err);
      });;
  }
  uploadFile(formData: FormData) {
    return this.http.post(this.API_URL + '/import', formData, {
      responseType: 'blob', headers: this._httpHeaders, observe: 'response'
    })
      .toPromise()
      .then((res) => {
        return statusCodeSuccess();
      }).catch((err) => {
        const stautsCode = new StatusCode();
        return checkCodeApi(stautsCode, err);
      });
  }

  synchronizedAPI7003(path: string, body?: any) {
    this._isLoading$.next(true);
    return this.http.post(this.API_EOFFICE_URL + path, body)
      .toPromise()
      .then((res) => {
        this._isLoading$.next(false);
        return res;
      }).catch((err) => {
        this._isLoading$.next(false);
        const stautsCode = new StatusCode();
        return checkCodeApi(stautsCode, err);
      });
  }

  synchronizedAPIAdmin(path: string, body?: any) {
    this._isLoading$.next(true);
    return this.http.post(this.API_ADMIN_URL + path, body, { headers: this._httpHeaders, })
      .toPromise()
      .then((res) => {
        this._isLoading$.next(false);
        return res;
      }).catch((err) => {
        this._isLoading$.next(false);
        const stautsCode = new StatusCode();
        return checkCodeApi(stautsCode, err);
      });
  }
  // assign permission to chart group
  assignChartGroups(ids: any[] = []): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = environment.apiUrl + '/decentralizations/add-chart-list-group';
    return this.http.post(url, ids, { headers: this._httpHeaders || null }).pipe(
      tap(() => {
        this._toast.success('Phân quyền thành công');
      }),
      catchError(err => {
        if (err && err.error && err.error.code === '400') {
          this._toast.error(err.error.message);
        }
        else {
          this._toast.error('Thao tác thất bại');
        }
        return of([]);
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }
}
